import { Trans } from '@lingui/macro'
import { SPORT_SUBGRAPH_URL } from 'constants/subgraph'
import request, { gql } from 'graphql-request'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useRefresh from 'hooks/useRefresh'
import { useEffect, useState } from 'react'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { isChainAllowed } from 'utils/switchChain'

import Events from './components/Events'
import HistoryBets from './components/HistoryBets'
import TopMatches from './components/TopMatches'
/* import TrendEvent from './components/TrendEvent' */

const PageWrapper = styled.div`
  max-width: 900px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 500px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 400px;
    margin-top: 5rem;
  `};
`

interface ISportProvider {
  id: string
  leagueName: string
  league: string
  sportType: string
}

interface IAcornSportEvents {
  id: string
  gameIndex: string
  homeTeam: string
  homeScore?: number
  awayTeam: string
  awayScore?: number
  statusId?: number
  startTime: string
  volumen?: string
  volumenHome: string
  volumenAway: string
  volumenDraw: string
  provider: ISportProvider
}

const threeHours = new Date().getTime() / 1000 - 10800
const weekAgo = new Date(new Date().setDate(new Date().getDate() - 7)).getTime() / 1000

function Sport() {
  const { fastRefresh } = useRefresh()
  const { account, chainId, connector } = useActiveWeb3React()
  const chainAllowed = chainId && isChainAllowed(connector, chainId)
  const apiUrl = SPORT_SUBGRAPH_URL[chainAllowed ? chainId : 137]
  const [schedules, setSchedules] = useState<IAcornSportEvents[]>([])
  const [dateQuery, setDateQuery] = useState<number>(threeHours)

  useEffect(() => {
    const getSportsEvents = async () => {
      const response = await request(
        apiUrl,
        gql`
          query {
            acornSportEvents(first: 500, orderBy: startTime, orderDirection: desc) {
              id
              gameIndex
              homeTeam
              homeScore
              awayTeam
              awayScore
              statusId
              startTime
              volumen
              volumenHome
              volumenAway
              volumenDraw
              provider {
                id
                leagueName
                league
                sportType
              }
            }
          }
        `
      )
      if (response.acornSportEvents.length > 0) {
        setSchedules(response.acornSportEvents)
      } else {
        setDateQuery(weekAgo)
      }
    }

    getSportsEvents()
  }, [apiUrl, account, fastRefresh, dateQuery])

  const from3Hours = schedules.filter((object) => Number(object.startTime) >= threeHours)

  const topBets = from3Hours
    ?.sort((a, b) =>
      a.volumen && b.volumen ? parseInt(b.volumen.length.toFixed()) - parseInt(a.volumen.length.toFixed()) : 0
    )
    .slice(0, 5)

  return (
    <PageWrapper>
      <ThemedText.LargeHeader mb="1rem">
        <Trans>Top Matches</Trans>
      </ThemedText.LargeHeader>

      <TopMatches topBets={topBets} />

      <ThemedText.LargeHeader mt="1rem">
        <Trans>Events</Trans>
      </ThemedText.LargeHeader>

      <Events bets={schedules} />
      <HistoryBets />
    </PageWrapper>
  )
}

export default Sport
